import { Component, OnInit } from '@angular/core';
import { MenuController, NavController, ToastController } from '@ionic/angular';
import { NotifyService } from '../services/notify.service';
import { SystemService } from '../services/system.service';
import { ThemeService } from '../services/theme.service';
import { Security } from '../utils/security.util';

import { Device } from '@awesome-cordova-plugins/device/ngx';
import { VersionService } from '../services/version.service';

@Component({
  selector: 'app-master',
  templateUrl: './master.page.html',
  styleUrls: ['./master.page.scss'],
})
export class MasterPage implements OnInit {
  exit = 0;
  name: string;
  document;
  standard;

   constructor(private navCtrl: NavController, private menuCtrl: MenuController, private themeService: ThemeService,
               private toastCtrl: ToastController, private systemService: SystemService, private notifyService: NotifyService,
               private versionService: VersionService, private device: Device, ) {
  }

  ngOnInit() {
    this.themeService.initAppTheme();

    this.name = Security.getName();
    this.document = Security.getDocument();
    this.standard = Security.getStandard();

    this.checkVersion();
    this.getProjectKey();
    this.startConnection();
  }

  checkVersion(){
    this.versionService.checkVersion(Security.versionApp()).subscribe(result => {
      if(result.success){
        console.log(result.message);
      } else{
        this.showMessage(result.message + ', versão ' + result.data.shortName + ' disponivel!');
        console.log(result.data);
      }
    });
  }


  goToPage(page: string) {
    this.menuCtrl.close('menuMain');
    this.navCtrl.navigateRoot(page);
  }

  ionViewCanLeave(): boolean {
    this.exit += 1;
    if (this.exit === 2) {
      return true;
    } else {
      this.showMessage('Pressione mais uma vez para sair!');
    }
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen,  duration: 3000 });
    error.present();
  }

  getProjectKey() {
    this.systemService.getProjectKey().subscribe(result => {
      if (result.success) {
        Security.setProjectKey(result.data.projectKey);
      }
    });
  }

  startConnection(){
    const uuid = this.device.uuid;
      const model = this.device.model;
      const serial = this.device.serial;
      const platform = this.device.platform;
      const version = this.device.version;
      this.notifyService.startConnection(Security.getProjectKey(), Security.getId(), uuid, model, serial, platform, version);
  }

}
